// src/utils/urlHelpers.js
export const getFullImageUrl = (fileName) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    return `${baseUrl}/Uploads/${fileName}`;
  };
  